<template>
    <div>
        <el-tabs  type="card" v-model="activeName">
            <el-tab-pane label="修改密码"  name="second">
                <el-form class="upsertForm" :model="pwdForm" :rules="pwdFormRules" ref="pwdForm" label-width="100px">
                    <el-form-item label="原密码" prop="password">
                        <el-input size="mini" type="password" v-model="pwdForm.password" auto-complete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="新密码" prop="newPassword">
                        <el-input size="mini" type="password" v-model="pwdForm.newPassword" auto-complete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="重复新密码" prop="newPassword2">
                        <el-input size="mini" type="password" v-model="pwdForm.newPassword2" auto-complete="off"></el-input>
                    </el-form-item>
                </el-form>
                <div  class="dialog-footer" >
                    <el-button size="mini" @click="closeDialog">取 消</el-button>
                    <el-button size="mini" type="primary"  @click="updatePassword()">确 定</el-button>
                </div>
            </el-tab-pane>
        </el-tabs>

    </div>
</template>

<script>
    import axios from 'axios'
    import md5 from 'md5'
    export default {
        name: "studentPersonal",
        data(){
            var validatePass = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请输入密码'));
                } else {
                    if (this.pwdForm.newPassword !== '') {
                        this.$refs.pwdForm.validateField('newPassword2');
                    }
                    callback();
                }
            };
            var validatePass2 = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请再次输入密码'));
                } else if (value !== this.pwdForm.newPassword) {
                    callback(new Error('两次输入密码不一致!'));
                } else {
                    callback();
                }
            };
            return {
                portrait:'',
               // ok:false,
                activeName:'second',
                config:config,
                uploadAvatarUrl:`${home}/upload/uploadAvatar`,
                upsertForm:{
                    id:'',
                    /*username:'',*/
                    password:'',
                    realName:'',
                    phone:'',
                    email:'',
                    portrait:'',
                    createTime:'',
                    educationBureauId:''
                },
                rules: {
                   /* username: [
                        { required: true, message: '请输入用户名', trigger: 'blur' }
                    ],*/
                    realName: [
                        { required: true, message: '请输入真实考生姓名', trigger: 'blur' }
                    ],
                    phone: [
                        {required: true, message: '请输入联系电话', trigger: 'blur'},
                        {min:11, message: '必须是11位长度', trigger: 'blur'},
                        {max:11, message: '必须是11位长度', trigger: 'blur'}
                     ],
                    email: [
                        {required: true, message: '请输入email', trigger: 'blur'},
                        {type:'email', message: '请输入email', trigger: 'blur'}
                    ],
                    portrait: [
                        { required: true, message: '请输入头像', trigger: 'blur' }
                    ]
                  /*  createTime: [
                        { required: true, message: '请输入创建时间', trigger: 'blur' }
                    ]*/
                },
                pwdForm:{
                    password:'',
                    newPassword:'',
                    newPassword2:''
                },
                pwdFormRules:{
                    password:[
                        {required: true, message: '请输入原始密码', trigger: 'blur'}
                    ],
                    newPassword:[
                        { validator: validatePass, trigger: 'blur' }
                    ],
                    newPassword2:[
                        { validator: validatePass2, trigger: 'blur' }
                    ],
                }
            }
        },
        created(){
            axios({
                url:`${home}/sysStudent/ignore/findMySelf`,
                method:'GET'
            }).then(res=>{
                Object.assign(this.upsertForm,res.data);
            })
        },
        methods:{
            closeDialog(){
                this.$emit('update:visible',false);
            },
            uploadAvatarSuccess(response, file, fileList){
                this.upsertForm.portrait=response;
                loading.close();
            },
            updateMySelf(){
                this.$refs['upsertForm'].validate(valid =>{
                    if(valid){
                        axios({
                            url:`${home}/sysStudent/ignore/updateMySelf`,
                            method:"POST",
                            data:this.upsertForm
                        }).then(res=>{
                            this.$store.commit('setAdmin', res.data);
                            this.$message({
                                showClose: true,
                                message: '个人设置修改成功',
                                type: 'success'
                            });
                            this.closeDialog();

                        })
                    }
                })

            },
            updatePassword(){
                this.$refs['pwdForm'].validate(valid =>{
                    if(valid){
                        axios({
                            url:`${home}/sysStudent/ignore/updateMyPassword`,
                            method:'POST',
                            data:{password:md5(this.pwdForm.password),newPassword:md5(this.pwdForm.newPassword)}
                        }).then(res=>{
                            this.$message({
                                showClose: true,
                                message: '修改密码成功',
                                type: 'success'
                            });
                            this.closeDialog();
                            this.$router.replace('/login');
                        })
                    }
                })

            },
            beforeAvatarUpload(file){
                loading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                })
            },
            avatarUploadProgress(event, file, fileList){

            },
            uploadAvatarError(err, file, fileList){
                loading.close();
            }
        },
        computed:{
            adminAvatar(){
                return config.resPre+this.upsertForm.portrait;
            }
        }
    }
    let loading;
</script>

<style scoped lang="scss">
    .upsertForm {
        padding: 20px 50px;
        .el-input, .el-textarea {
            width: 60%;
        }
    }
    .avatar{
        width:80px;
        height:80px;
        border-radius: 5px;
    }
    .dialog-footer{
        text-align: center;
    }
</style>